import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetCollectionComponentTypeByIdMultilingual = () => {
  return useContentSelector(
    ({ collectionComponentTypes }) =>
      collectionComponentTypes.collectionComponentTypeByIdMultilingual
  );
};

export const useCreateCollectionComponentTypeMultilingual = () => {
  return useContentSelector(
    ({ collectionComponentTypes }) =>
      collectionComponentTypes.createCollectionComponentTypeMultilingual
  );
};

export const useEditCollectionComponentTypeMultilingual = () => {
  return useContentSelector(
    ({ collectionComponentTypes }) =>
      collectionComponentTypes.editCollectionComponentTypeMultilingual
  );
};
